<template>
    <div>
        <div v-if="series.length > 0">
            <apexchart
                type="bar"
                :options="chartOptions"
                :height="chartHeight"
                :series="series"
                ref="chart"
            ></apexchart>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        year: {
            type: [Number, String],
            default: () => new Date().getFullYear(),
        },
        month: {
            type: [Number, String],
            default: () => new Date().getMonth() + 1,
        },
    },
    data: () => ({
        chartOptions: {
            char: {
                type: 'bar',
                stacked: false,
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                    barHeight: '80%',
                    distributed: false,
                },
            },
            colors: ['#008FFB', '#00E396'],
            dataLabels: {
                enabled: false,
            },
            xaxis: {
                tickAmount: undefined,
                labels: {
                    formatter: function (val) {
                        return Math.floor(val)
                    },
                },
                min: undefined,
                max: undefined,
                position: 'top',
            },
            yaxis: {
                title: {
                    text: 'Supervisores',
                },
                labels: {
                    maxWidth: 300,
                },
            },
            tooltip: {
                x: {
                    formatter: function (val) {
                        return val
                    },
                },
            },
            title: {
                text: 'Listas por supervisor',
                align: 'center',
            },
            legend: {
                show: true,
                position: 'top',
                markers: {
                    fillColors: ['#008FFB', '#00E396'], // Asegura que los marcadores de la leyenda usen los mismos colores
                },
            },
        },
        series: [],
    }),
    watch: {
        // chartHeight(height) {
        //     if (!this.$refs.chart) return
        //     this.chartOptions.height = height
        //     this.$refs.chart.updateOptions(this.chartOptions)
        // },
    },
    computed: {
        chartHeight() {
            if (this.series.length === 0) return 900
            return Math.max(this.series[0].data.length * 40, 900)
        },
    },
    methods: {
        fetchData() {
            this.series = []
            this.loadIndicators()
        },
        async loadIndicators() {
            try {
                const { data } = await this.$repo.get(
                    'dashboards/supervisors/checklists',
                    {
                        year: this.year,
                        month: this.month,
                    }
                )
                const categories = data.map((item) => item.name)

                this.series = [
                    {
                        name: 'Listas de chequeo',
                        data: data.map(({ name, checklists }) => ({
                            x: name,
                            y: parseInt(checklists),
                        })),
                    },
                    {
                        name: 'Clientes visitados',
                        data: data.map(({ name, clients }) => ({
                            x: name,
                            y: parseInt(clients),
                        })),
                    },
                ]
                this.chartOptions.xaxis.categories = categories
                const tickAmount = Math.min(
                    (this.chartOptions.xaxis.tickAmount = data
                        .map((item) => parseInt(item.checklists))
                        .reduce((carry, item) => Math.max(carry, item), 0)),
                    20
                )
                this.chartOptions.xaxis.tickAmount = tickAmount
                //     data.map((item) => parseInt(item.checklists))
                // )
                this.$nextTick(() => {
                    this.$refs.chart.updateOptions(this.chartOptions)
                })
                this.$emit('loaded', data)
            } catch (error) {
                console.log({ error })
                toastr.error('Error al cargar los datos')
            }
        },
    },
    mounted() {
        this.loadIndicators()
    },
}
</script>
